import { loadStripe } from '@stripe/stripe-js';

let cachedPromise = null;

const readKey = () =>
  (typeof window !== 'undefined' &&
    window.env?.REACT_APP_STRIPE_PUBLISHABLE_KEY) ||
  process.env?.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  null;

export const loadStripeFromEnv = () => {
  if (cachedPromise) return cachedPromise;
  const key = readKey();
  if (!key) return null;
  cachedPromise = loadStripe(key);
  return cachedPromise;
};
